import {ReturnItem} from '@cypro/engine/schema'
import {Box, Text, IconButton} from '@chakra-ui/react'
import {getShortDateFormatter} from '@cypro/ui/utils'
import {useTranslate} from '@tolgee/react'
import {LuTrash2} from 'react-icons/lu'

interface ReturnRowProps {
  returnItem: ReturnItem
  onRemove?: () => void
}

export function ReturnRow({returnItem, onRemove}: ReturnRowProps) {
  const {t} = useTranslate('common')
  const expiryDate = returnItem.expiryDate ? getShortDateFormatter().format(new Date(returnItem.expiryDate)) : '-'
  const returnedAt = returnItem.returnedAt ? getShortDateFormatter().format(new Date(returnItem.returnedAt)) : '-'

  return (
    <Box display="flex" flexDirection="row" gap="2" alignItems="center" paddingInline="2" paddingBlock="1.5">
      <Box display="flex" flexDirection="column" justifyContent="center" flex="1">
        <Box display="flex" flexDirection="row" gap="1" alignItems="center">
          <Text fontSize="sm" fontWeight="medium">
            {returnItem.medicationName || '-'}
          </Text>
        </Box>
        {returnItem.medicationForm && (
          <Text fontSize="12px" fontWeight="normal" color="fg.muted">
            {returnItem.medicationForm}
          </Text>
        )}
        <Text fontSize="12px" fontWeight="normal" color="fg.muted">
          {t('expiry_date')}: {expiryDate}
        </Text>
        <Text fontSize="12px" fontWeight="normal" color="fg.muted">
          {t('returned_at')}: {returnedAt}
        </Text>
        {returnItem.stockLocationName && (
          <Text fontSize="12px" fontWeight="normal" color="fg.muted">
            {t('stock_location')}: {returnItem.stockLocationName}
          </Text>
        )}
        {returnItem.reason && (
          <Text fontSize="12px" fontWeight="normal" color="fg.muted">
            {t('reason')}: {t(`return_reason.${returnItem.reason}`)}
          </Text>
        )}
        {returnItem.note && (
          <Text fontSize="12px" fontWeight="normal" color="fg.muted">
            {t('notes')}: {returnItem.note}
          </Text>
        )}
      </Box>
      {onRemove && (
        <IconButton size="sm" variant="ghost" color="fg.error" title={t('remove')} onClick={onRemove}>
          <LuTrash2 />
        </IconButton>
      )}
    </Box>
  )
}
